export const en = {
    placeholder: 'Product name',
    search: 'search'
};
